/** Runtime and Admin use one parser and the same historical feature defaults.
 * Provisioning must explicitly disable integrations for new customer installs.
 */
export const featureDefaults = {
  ebay: true,
  googleMerchant: true,
  idealo: true,
  orderTracking: true,
  priceSpy: true,
  productImports: true,
}
export type FeatureName = keyof typeof featureDefaults

export const parseBoolean = (value: string | undefined, fallback: boolean): boolean => {
  if (typeof value !== 'string' || value.trim() === '') return fallback
  const normalized = value.trim().toLowerCase()
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false
  return fallback
}

export const resolveFeatureFlag = (feature: FeatureName, value: string | undefined): boolean =>
  parseBoolean(value, featureDefaults[feature])
